exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ujcJ{margin:0 auto;max-width:1000px;width:100%}._1ujcJ+._1ujcJ{margin-top:32px;margin-top:2rem}@media screen and (min-width:768px){._1ujcJ+._1ujcJ{margin-top:3rem}}._3WobU{margin-left:-16px;margin-left:-1rem;margin-right:-16px;margin-right:-1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}._2JzFG,._3WobU{-webkit-box-flex:0}._2JzFG{padding-left:16px;padding-left:1rem;padding-right:16px;padding-right:1rem;-ms-flex:0 0 auto;flex:0 0 auto;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:100%;max-width:100%}@media screen and (min-width:768px){._2JzFG{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}}@media screen and (min-width:768px){._38mX1{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}}@media screen and (min-width:992px){._3do23{max-width:400px}}._3AIGd{-ms-flex-item-align:center;align-self:center}._3AIGd img{width:100%;display:block;max-width:100%;height:auto}@media screen and (max-width:767px){._3AIGd{margin-bottom:1rem}}._2K2Td{-ms-flex-item-align:center;align-self:center}", ""]);

// exports
exports.locals = {
	"root": "_1ujcJ",
	"row": "_3WobU",
	"col": "_2JzFG",
	"inverse": "_38mX1",
	"title": "_3do23",
	"image": "_3AIGd",
	"text": "_2K2Td"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Teaser/TextImage/TextImage.css
// module id = 690
// module chunks = 2